// 组件类
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "rs-tag-input",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.scss"],
})
export class TagInputComponent implements OnInit {
  @Input() value = [];
  @Input() fields;
  @Input() disabled = false;
  @Input() error = false;
  @Input("inputMinlength") minlength = 3;
  @Input("inputMaxlength") maxlength = 30;

  get inputMinlength() {
    return this.minlength === undefined ? 3 : this.minlength;
  }

  get inputMaxlength() {
    return this.minlength === undefined ? 30 : this.maxlength;
  }

  @Output()
  valueChange = new EventEmitter();

  @Output() focus = new EventEmitter();
  @Output() blur = new EventEmitter();
  @Output() keyup = new EventEmitter();

  ngOnInit() {}
  onRemoveTag(tag) {
    const tagsList = this.value.filter((i) => i !== tag);
    this.valueChange.emit(tagsList);
  }

  onAddTag(event, type?) {
    const inputValue = event.target.value;
    if (inputValue && this.verifyInputValue(inputValue)) {
      this.valueChange.emit([...this.value, inputValue]);
      event.target.value = "";
    }
    if (!type) this.keyup.emit(event);
  }
  inputError = false;
  verifyInputValue(inputValue) {
    this.inputError = false;
    const inputValueLength = inputValue.length;
    if (
      this.value.includes(inputValue) ||
      inputValueLength > this.inputMaxlength ||
      inputValueLength < this.inputMinlength
    ) {
      this.inputError = true;
      return false;
    }
    return true;
  }

  onInput() {
    this.inputError = false;
  }

  onFocus() {
    this.focus.emit();
  }

  onBlur(event: any) {
    this.onAddTag(event, "blur");
    this.blur.emit();
  }
}
